module.exports = __webpack_public_path__ + "static/media/new-step-indicator-3.ec94e973.svg";